<form class="modal-body mb-0" [formGroup]="form" (ngSubmit)="updateSecurityVerificationMutation()" novalidate *ngIf="!verifyPhoneExisting">
  <p class="centermodal__title">{{ 'documents.phoneVerification' | translate }}</p>
  <p class="centermodal__description">{{ 'documents.enterPhoneNumber' | translate }}</p>

  <div class="centermodal__form">
    <label class="field__holder">
      <app-phone-number inputClass="field" formControlName="phoneNumber" name="phoneNumber" autocomplete="tel-national" required></app-phone-number>
      <span class="field__placeholder">{{ 'documents.yourPhoneNumber' | translate }}</span>
      <small [hidden]="!form.get('phoneNumber').value || !form.get('phoneNumber').hasError('phoneError')" class="text-danger">{{ 'error_invalid_phone_number' | translate }}</small>
    </label>
  </div>

  <div class="centermodal__button-group">
    <button type="button" class="btn-M btn-filled-cancel" [disabled]="isLoading" (click)="modal.dismiss()">{{ 'button.cancel' | translate }}</button>
    <button type="submit" class="btn-M btn-filled" [disabled]="form.invalid || isLoading">{{ 'button.forward' | translate }}</button>
  </div>
</form>

<form class="modal-body mb-0" (ngSubmit)="submitToken()" *ngIf="verifyPhoneExisting" novalidate>
  <p class="centermodal__title">{{ 'documents.confirmPhoneNumber' | translate }}</p>
  <p class="centermodal__description" [innerHTML]="phoneOtpProvider.translation('documentCodeSent', currentPhoneOtpProvider) | translate: { phone: formattedPhone }"></p>

  <div class="tokenText__container">
    <label class="field__holder" [appFormControlWrap]="token">
      <input type="tel" class="field" [formControl]="token" name="token" autocomplete="one-time-code" maxlength="6" appOnlyNumbers required />
      <span class="field__placeholder">{{ 'auth.confirmCode' | translate }}</span>
    </label>

    <div class="tokenField">
      <p class="tokenField__alert" *ngIf="isInvalidToken"><i class="tokenField__alert-icon"></i> {{ 'documents.incorrectCode' | translate }}</p>
      <div class="tokenField__resend">
        <span class="tokenField__resend-text">{{ 'documents.didntReceiveCode' | translate }}</span>
        <button type="button" class="btn btn-link btnAnimatedBackground tokenText__btn" (click)="sendSecurityCode(); timeOutForWhatsappVerification()" [disabled]="isVerifyingToken">
          {{ 'documents.resendCode' | translate }}
        </button>
      </div>
      <div class="tokenField__resend-text tokenText" *ngIf="hasPhoneOtpFallbackProvider()">
        <span class="tokenField__resend-text">{{ 'documents.orTryBy' | translate }}</span>
        <button
          type="button"
          class="btn btn-link btnAnimatedBackground tokenText__btn greenText"
          [disabled]="isLoading || whatsAppTimer.isCountdownInProgress()"
          (click)="sendFallbackSecurityCode(); timeOutForWhatsappVerification()"
        >
          <span class="tokenText__type">{{ phoneOtpFallbackProviderLabel() }}</span>
          &nbsp;{{ (whatsAppTimer.isCountdownInProgress() ? 'documents.in' : '') | translate }}
          <div>&nbsp;{{ whatsAppTimer.isCountdownInProgress() ? formattedTime : '' }}</div>
        </button>
      </div>
    </div>
  </div>
  <div class="centermodal__button-group mt-3">
    <button type="button" class="btn-M btn-filled-cancel" [disabled]="isLoading" (click)="modal.dismiss()">{{ 'button.back' | translate }}</button>
    <button type="submit" class="btn-M btn-filled" [disabled]="isLoading">{{ 'button.forward' | translate }}</button>
  </div>
</form>
